<template>
  <v-dialog
    :value="value"
    fullscreen
    @input="$emit('input', $event)"
    transition="dialog-bottom-transition"
  >
    <v-card dark style="background: rgba(0, 0, 0, 0.95)">
      <!-- Header -->
      <v-toolbar dark flat color="transparent">
        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>
          {{ currentIndex + 1 }} / {{ images.length }}
        </v-toolbar-title>
        <v-spacer />
        <v-btn icon :href="currentImageUrl" download target="_blank">
          <v-icon>mdi-download</v-icon>
        </v-btn>
        <v-btn icon @click="shareImage">
          <v-icon>mdi-share-variant</v-icon>
        </v-btn>
      </v-toolbar>

      <!-- Image Carousel -->
      <v-carousel
        v-model="currentIndex"
        height="calc(100vh - 64px)"
        hide-delimiter-background
        show-arrows-on-hover
        :show-arrows="images.length > 1"
      >
        <v-carousel-item
          v-for="(image, i) in images"
          :key="i"
        >
          <v-sheet
            height="100%"
            color="transparent"
            class="d-flex align-center justify-center"
          >
            <v-img
              :src="getImageUrl(image)"
              contain
              max-height="100%"
              max-width="100%"
              @click="close"
            >
              <template v-slot:placeholder>
                <v-row
                  class="fill-height ma-0"
                  align="center"
                  justify="center"
                >
                  <v-progress-circular
                    indeterminate
                    color="grey lighten-5"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-sheet>
        </v-carousel-item>
      </v-carousel>

      <!-- Thumbnail Navigation (if multiple images) -->
      <div
        v-if="images.length > 1"
        class="d-flex justify-center pa-2"
        style="position: absolute; bottom: 0; left: 0; right: 0; background: rgba(0, 0, 0, 0.5)"
      >
        <v-sheet
          v-for="(image, i) in images"
          :key="i"
          :class="{ 'thumbnail-active': i === currentIndex }"
          class="thumbnail ma-1"
          @click="currentIndex = i"
        >
          <v-img
            :src="getImageUrl(image)"
            height="60"
            width="60"
            cover
          />
        </v-sheet>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ImagePreviewDialog',

  props: {
    value: {
      type: Boolean,
      default: false
    },
    images: {
      type: Array,
      default: () => []
    },
    initialIndex: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      currentIndex: 0
    };
  },

  computed: {
    currentImageUrl() {
      if (this.images.length === 0) return '';
      return this.getImageUrl(this.images[this.currentIndex]);
    }
  },

  watch: {
    value(newVal) {
      if (newVal) {
        this.currentIndex = this.initialIndex;
      }
    },

    initialIndex(newVal) {
      this.currentIndex = newVal;
    }
  },

  methods: {
    getImageUrl(image) {
      if (!image) return '';

      // Check if it's already a full URL
      if (image.startsWith('http')) {
        return image;
      }

      return this.mediaUrl + image;
    },

    close() {
      this.$emit('input', false);
    },

    shareImage() {
      if (navigator.share) {
        navigator.share({
          title: 'Share Image',
          url: this.currentImageUrl
        }).catch((error) => {
          console.log('Error sharing:', error);
        });
      } else {
        // Fallback: copy to clipboard
        navigator.clipboard.writeText(this.currentImageUrl)
          .then(() => {
            this.$toast.success('Image URL copied to clipboard');
          })
          .catch(() => {
            this.$toast.error('Failed to copy URL');
          });
      }
    }
  }
};
</script>

<style scoped>
.thumbnail {
  cursor: pointer;
  border: 2px solid transparent;
  transition: all 0.2s;
}

.thumbnail:hover {
  border-color: white;
}

.thumbnail-active {
  border-color: var(--v-primary-base) !important;
  box-shadow: 0 0 10px var(--v-primary-base);
}
</style>
